import React, { useEffect, useState } from "react";

export type ReceiptImage = {
  url: string;
  label?: string;
};

export function collectReceiptImages(src?: {
  image_url?: string | null;
  extra_images?: { url: string; label?: string }[] | null;
} | null): ReceiptImage[] {
  if (!src) return [];
  const out: ReceiptImage[] = [];
  if (src.image_url) out.push({ url: src.image_url, label: "Otpremnica" });
  for (const img of src.extra_images || []) {
    if (img?.url) out.push({ url: img.url, label: img.label || "Lot" });
  }
  return out;
}

const ReceiptImageThumb: React.FC<{
  images: ReceiptImage[];
  empty?: React.ReactNode;
}> = ({ images, empty = null }) => {
  const [open, setOpen] = useState<number | null>(null);
  const list = (images || []).filter((i) => i?.url);

  useEffect(() => {
    if (open == null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(null);
      if (e.key === "ArrowRight") setOpen((i) => (i == null ? i : (i + 1) % list.length));
      if (e.key === "ArrowLeft") setOpen((i) => (i == null ? i : (i - 1 + list.length) % list.length));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, list.length]);

  if (!list.length) return <>{empty}</>;

  return (
    <>
      <div className="receipt-thumbs">
        {list.map((img, i) => (
          <button
            key={`${img.url}-${i}`}
            type="button"
            className="receipt-thumb"
            title={img.label || "Otpremnica"}
            onClick={() => setOpen(i)}
          >
            <img src={img.url} alt={img.label || "Otpremnica"} />
            {img.label ? <span>{img.label}</span> : null}
          </button>
        ))}
      </div>
      {open != null && list[open] ? (
        <div className="receipt-lightbox" onClick={() => setOpen(null)} role="dialog" aria-modal>
          <img
            src={list[open].url}
            alt={list[open].label || "Otpremnica"}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="receipt-lightbox-bar" onClick={(e) => e.stopPropagation()}>
            <span>{list[open].label || "Otpremnica"}</span>
            {list.length > 1 ? (
              <span>
                {open + 1}/{list.length}
              </span>
            ) : null}
            <a href={list[open].url} target="_blank" rel="noreferrer">
              otvori original
            </a>
            <button type="button" onClick={() => setOpen(null)}>
              zatvori
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ReceiptImageThumb;
